module.exports = __webpack_public_path__ + "static/media/lock-icon.6ad9d070.svg";